<template>
  <div>
    <div class="form-row">
      <div
        class="col-12 d-flex align-items-center flex-wrap mb-3 flex-column flex-sm-row text-center"
      >
        <h5 class="text-blue-ml">* Educación</h5>

        <button
          type="button"
          class="btn btn-outline-blue-ml ml-0 ml-sm-auto"
          @click="edit(null)"
        >
          Agregar Formación
        </button>
      </div>

      <div
        class="col-12 mb-4"
        v-for="(education, index) in educations"
        :key="index"
      >
        <div
          class="d-flex align-items-center justify-content-between justify-content-md-start"
        >
          <div class="mr-3" v-if="education.institutionName">
            <h5 class="mb-0">{{ education.institutionName }}</h5>
            <p class="mb-0">
              {{ education.level == "high_school" ? "Secundaria" : "" }}
              {{ education.level == "technical" ? "Preparatoria o Bachillerato" : "" }}
              {{ education.level == "graduation" ? "Universidad" : "" }}
              {{ education.level == "postgraduation" ? "Posgrado o Masters" : "" }}

              <span v-if="education.courseName">,</span>

              {{ education.courseName }}
            </p>
          </div>
          <div class="mr-3" v-else>
            <h5 class="mb-0">
              {{
                $store.state.domains.education_levels.find(
                  (edL) => edL.id == education.level
                )["description"]
              }}
            </h5>
          </div>

          <div class="btn-group" role="group">
            <button
              type="button"
              class="btn btn-light"
              @click="edit(education)"
            >
              <pencil-icon class="align-text-bottom text-blue-ml" />
            </button>
            <button
              type="button"
              class="btn btn-light"
              @click="remove(education.id)"
            >
              <delete-icon class="align-text-bottom text-blue-ml" />
            </button>
          </div>
        </div>

        <p class="text-muted" v-if="education.startDate || education.endDate">
          <span v-if="education.startDate"
            >{{ $moment(education.startDate).format("YYYY") }} -</span
          >
          <span v-if="education.endDate">
            {{
              $moment(education.endDate).isAfter()
                ? " (Fecha estimada de finalización " +
                  $moment(education.endDate).format("YYYY") +
                  ")"
                : $moment(education.endDate).format("YYYY")
            }}
          </span>
        </p>
      </div>
    </div>

    <!-- A flag de não possuo formação só deve aparecer para Kabum (isKabumUser) -->
    <div class="custom-control custom-checkbox pb-3 pl-0 w-100" v-if="educations.length == 0 && isKabumUser">
      <div class="d-flex pb-4">
        <input type="checkbox" class="custom-control-input" style="position: relative; width: 1.7rem;" :id="'no-educations' + format" v-model="no_educations" value="true">
        <label class="custom-control-label" :for="'no-educations' + format">No tengo formacion</label>
      </div>
    </div>

    <b-modal
      ref="modal-education"
      size="lg"
      centered
      :hide-header="true"
      :hide-footer="true"
      no-close-on-backdrop
      lazy
    >
      <div class="py-4 px-2 px-lg-4">
        <h4 class="text-blue-ml mb-4">Educación</h4>

        <button
          type="button"
          class="ml-auto close"
          @click="$refs['modal-education'].hide()"
        >
          <close-icon class="h4 my-0 ml-auto" />
        </button>

        <FormEducation
          @closeModal="$refs['modal-education'].hide()"
          hasButtons
        />
      </div>
    </b-modal>

    <div
      v-if="
        format == 'inline-form' &&
        educations.length == 0 &&
        $route.name == 'deixe-seu-perfil'
      "
      v-show="no_educations == false && isKabumUser"
    >
      <div
        class="form-area mb-5"
        :class="{ 'has-multiple': formsIds.length > 1 }"
        v-for="(item, index) in formsIds"
        :key="index"
      >
        <FormEducation storeByEventBus />
        <div class="d-flex" v-if="formsIds.length > 1">
          <button
            class="btn btn-link btn-lg p-0 ml-auto"
            @click="removeForm(item)"
          >
            <u>Quitar entrenamiento</u>
          </button>
        </div>
      </div>

      <div class="d-flex">
        <button
          class="btn btn-outline-blue-ml btn-lg mx-auto"
          @click="addForm()"
        >
          Agregar entrenamiento
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue';
import PencilIcon from 'vue-material-design-icons/Pencil.vue';
import DeleteIcon from 'vue-material-design-icons/Delete.vue';
import FormEducation from './FormEducationEs.vue';

export default {
  name: 'BoxEducation',

  data() {
    return {
      formsIds: [new Date().getTime()],
    };
  },

  computed: {
    educations() {
      const { user } = this.$store.state;
      if (user.profile) {
        return user.profile.educations
          ? this.$helpers.sortBy(user.profile.educations, 'endDate', 'desc')
          : [];
      }
      return [];
    },

    no_educations: {
      set(newValue) {
        this.$store.commit('SET_FLAG_EDUCATIONS', newValue);
      },
      get() {
        return this.$store.state.flag_no_educations;
      },
    },

    isKabumUser() {
      return localStorage.getItem('isKabumUser') && localStorage.getItem('isKabumUser') == 'true';
    },
  },

  props: {
    format: {
      type: String,
      default: 'inline-form',
    },
  },

  components: {
    CloseIcon,
    PencilIcon,
    DeleteIcon,
    FormEducation,
  },

  methods: {
    addForm() {
      this.formsIds.push(new Date().getTime());
    },

    removeForm(item) {
      this.$swal({
        title: 'Aviso',
        text: '¿Estás seguro de que quieres eliminar la Formación?',
        type: 'error',
        showCancelButton: true,
        cancelButtonText: 'No',
        confirmButtonText: 'Sí, quiero eliminar',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.formsIds = this.formsIds.filter((form) => form !== item);
        }
      });
    },

    edit(education) {
      this.$refs['modal-education'].show();
      setTimeout(
        () => this.$EventBus.$emit('editingEducation', education),
        100,
      );
    },

    remove(id) {
      if (!id) return;

      this.$swal({
        title: 'Aviso',
        text: '¿Estás seguro de que quieres eliminar la Formación?',
        type: 'error',
        showCancelButton: true,
        cancelButtonText: 'No',
        confirmButtonText: 'Sí, quiero eliminar',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('user/educationDelete', { id });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
